<div id="instrumentTypeForm">
    <span *ngIf="title" class="text-3xl font-semibold">{{ title }}</span>
    <div *ngIf="instrumentType" class=" pb-0 m-0 overflow-auto">

        <form [formGroup]="instrumentTypeForm" >

            <!-- First Row -->
            <div class="grid grid-cols-1 md:grid-cols-5 gap-4 w-full">
                <mat-form-field dense appearance="outline" class="col-span-4 flex items-center justify-center">
                    <mat-label>{{ 'NAME_LABEL' | translate }}</mat-label>
                    <mat-icon matSuffix class="text-gray-500">storefront</mat-icon>
                    <input name="name" formControlName="name" matInput required>
                </mat-form-field>
                <mat-form-field dense appearance="outline" floatLabel="always" class="flex items-center justify-center">
                    <mat-label>ICC</mat-label>
                    <mat-select formControlName="icc" [compareWith]="compareIcc">
                        <mat-option *ngFor="let icc of iccList" [value]="icc">
                            {{ icc.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

                <!-- Second Row -->
            <div class="grid grid-cols-1 md:grid-cols-5 gap-4 w-full">
                <mat-form-field dense appearance="outline" floatLabel="always" class="flex items-center justify-center">
                    <mat-label>Precio Calibración</mat-label>
                    <input name="calibrationPrice" formControlName="calibrationPrice" matInput>
                </mat-form-field>
                <mat-form-field dense appearance="outline" floatLabel="always" class="flex items-center justify-center">
                    <mat-label>Precio de Batería</mat-label>
                    <input name="batteryPrice" formControlName="batteryPrice"  matInput>
                </mat-form-field>
                <mat-form-field dense appearance="outline" floatLabel="always" class="flex items-center justify-center">
                    <mat-label>Precio Estuche</mat-label>
                    <input name="casePrice" formControlName="casePrice" matInput>
                </mat-form-field>
                <mat-form-field dense appearance="outline" floatLabel="always" class="flex items-center justify-center">
                    <mat-label>Precio de Fusible</mat-label>
                    <input name="fusePrice" formControlName="fusePrice"  matInput>
                </mat-form-field>
                <mat-form-field dense appearance="outline" floatLabel="always" class="flex items-center justify-center">
                    <mat-label>Precio de cables</mat-label>
                    <input name="cablesPrice" formControlName="cablesPrice"  matInput>
                </mat-form-field>
            </div>


            <!-- Third Row -->
            <div class="flex flex-row gap-4">
                <mat-form-field dense appearance="outline" floatLabel="always" class="w-full">
                    <mat-label>{{ 'LABEL_DESCRIPTION' | translate }}</mat-label>
                    <textarea name="description" formControlName="description" rows="10" matInput></textarea>
                </mat-form-field>
            </div>



<!--            &lt;!&ndash; Attributes Row &ndash;&gt;-->
<!--            <div *ngIf="attributes && attributes.length > 0">-->
<!--                <attributes #attributesComp [form]="instrumentTypeForm" [values]="attributes"></attributes>-->
<!--            </div>-->
        </form>

        <!-- Buttons -->
        <div *ngIf="_systemService.canAction('adminClients')" class="flex justify-end gap-4 mt-4">
            <button *ngIf="action !== 'edit'"
                    mat-button mat-raised-button color="warn"
                    (click)="deleteInstrumentType()"
                    [disabled]="instrumentTypeForm.invalid"
                    aria-label="DELETE">
                Borrar
            </button>
            <button *ngIf="action !== 'edit'"
                    mat-button mat-raised-button color="accent"
                    (click)="guardarInstrumentType()"
                    [disabled]="instrumentTypeForm.invalid"
                    aria-label="SAVE">
                Guardar
            </button>
        </div>
    </div>

    <!-- No Client Selected -->
    <div *ngIf="!instrumentType">
        <span>Debe seleccionar un tipo de instrumento para modificar o presionar 'Nuevo' para crear un cliente nuevo</span>
    </div>
</div>
